import { CameraDetail } from '@hakimo-ui/hakimo/types';
import { useState } from 'react';
import { UpdateLivestreamUrl } from '../settings/update-fields/UpdateLivestreamUrl';
import UpdateLocation from '../settings/update-fields/UpdateLocation';
import { UpdateName } from '../settings/update-fields/UpdateName';
import { UpdateRtspUrl } from '../settings/update-fields/UpdateRtspUrl';
import { UpdateArmedStatus } from '../settings/update-fields/update-armed-status/UpdateArmedStatus';
import UpdateAutomatedTalkdownWindow from '../settings/update-fields/update-automated-talkdown-window/UpdateAutomatedTalkdownWindow';

const AUTOMATED_TALKDOWN_TIMEZONE = 'UTC';

interface UseOverviewModalsReturn {
  openUpdateName: () => void;
  openUpdateRtspUrl: () => void;
  openUpdateLivestreamUrl: () => void;
  openUpdateLocation: () => void;
  openUpdateArmedStatus: () => void;
  openUpdateAutomatedTalkdown: () => void;
  renderModals: () => JSX.Element;
}

export function useOverviewModals(
  camera: CameraDetail
): UseOverviewModalsReturn {
  const [updateName, setUpdateName] = useState(false);
  const [updateRtspUrl, setUpdateRtspUrl] = useState(false);
  const [updateLivestreamUrl, setUpdateLivestreamUrl] = useState(false);
  const [updateLocation, setUpdateLocation] = useState(false);
  const [updateArmedStatus, setUpdateArmedStatus] = useState(false);
  const [updateAutomatedTalkdown, setUpdateAutomatedTalkdown] = useState(false);
  const cameraDisarmWindow = camera.armStatus.cameraDisarmWindow;
  const cameraInfoMessage = `Temporarily disarm monitoring for the specified period for camera ${camera.name}. Otherwise, monitoring will follow the site monitoring schedule.`;

  const renderModals = () => (
    <>
      {updateName && (
        <UpdateName
          cameraId={camera.id}
          name={camera.name}
          onClose={() => setUpdateName(false)}
        />
      )}
      {updateRtspUrl && (
        <UpdateRtspUrl
          cameraId={camera.id}
          rtspUrl={camera.rtspUrl}
          onClose={() => setUpdateRtspUrl(false)}
        />
      )}
      {updateLivestreamUrl && (
        <UpdateLivestreamUrl
          cameraId={camera.id}
          livestreamUrl={camera.livestreamUrl}
          onClose={() => setUpdateLivestreamUrl(false)}
        />
      )}
      {updateLocation && (
        <UpdateLocation
          cameraId={camera.id}
          locationId={String(camera.location?.id) || ''}
          onClose={() => setUpdateLocation(false)}
        />
      )}
      {updateArmedStatus && (
        <UpdateArmedStatus
          cameraId={camera.id}
          isArmed={camera.armStatus.isArmed}
          timezone={camera.location?.timezone || 'UTC'}
          cameraDisarmWindow={cameraDisarmWindow}
          onClose={() => setUpdateArmedStatus(false)}
          infoMessage={cameraInfoMessage}
        />
      )}
      {updateAutomatedTalkdown && (
        <UpdateAutomatedTalkdownWindow
          open={updateAutomatedTalkdown}
          camera={camera}
          timezone={AUTOMATED_TALKDOWN_TIMEZONE}
          onClose={() => setUpdateAutomatedTalkdown(false)}
        />
      )}
    </>
  );

  return {
    openUpdateName: () => setUpdateName(true),
    openUpdateRtspUrl: () => setUpdateRtspUrl(true),
    openUpdateLivestreamUrl: () => setUpdateLivestreamUrl(true),
    openUpdateLocation: () => setUpdateLocation(true),
    openUpdateArmedStatus: () => setUpdateArmedStatus(true),
    openUpdateAutomatedTalkdown: () => setUpdateAutomatedTalkdown(true),
    renderModals,
  };
}
